export { default } from './PremiumBadge.vue';
